import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PagerService } from '../../services/index';
import * as $ from 'jquery';

@Component({
	selector: 'app-answered-survey-report',
	templateUrl: './answered-survey-report.component.html',
	styleUrls: ['./answered-survey-report.component.css']
})
export class AnsweredSurveyReportComponent implements OnInit {
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any = 1;
	time: any = 0;
	answeredSurveyList: any;
	isReportAvailable: boolean = false;
	selectedSurveyOptions:any[];
	reportDate:any;
	idArr:any[];
	countArr:any[];
	isSurveyAvailable:boolean=true;
	isCountAvailable:boolean = true;
	redirectUrl:any;
	activePageNo:any;

	constructor(private router: Router, private activatedRoute: ActivatedRoute, private pagerService: PagerService, private authService: AuthService,
		private commonService: CommonService) { }

	ngOnInit() {
		this.limit = 10;
		this.pageNo = 1;
		let route = this.router.url;
		if(route.indexOf("?backUrl") !== -1){
			var routeArr = route.split('?backUrl=');
			var decodedUri = decodeURIComponent(routeArr[1]);
			var decodedArr = decodedUri.split("&");
			var decodedPageNo =  decodedArr[0].split("pageNo=");
			var decodedTime =  decodedArr[1].split("time=");
			this.pageNo = decodedPageNo[1];
			this.activePageNo = decodedPageNo[1];
			this.time = decodedTime[1];
		}
		this.getReportDate(this.time);
		$('#selectReport').val(this.time);
		this.commonService.process();
		this.getAnsweredSurveyList(this.pageNo, this.limit, this.time);
	}

	// Get Answered Survey List
	getAnsweredSurveyList = function (pageNo, limit, time) {
		this.commonService.process();
		this.authService.getAnsweredSurveyList(pageNo, limit, time).subscribe(data => {
			if(data.success){
				var that = this;
				if(pageNo == this.activePageNo)
				setTimeout(function(){ 
					$('#page_'+that.activePageNo).addClass('active');
					if(that.activePageNo == 1)
						$('#first, #prev').addClass('disabled');
					else if(that.activePageNo == that.pager.totalPages)
						$('#next, #last').addClass('disabled');
				},100);
				this.answeredSurveyList = data.survey;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
				this.isSurveyAvailable = true;
				this.redirectUrl = "pageNo="+pageNo+"&time="+time+"&type=2";
			}
			else{
				this.answeredSurveyList = [];
				this.isSurveyAvailable = false;
			}
			if(this.time==0){
				$(".navbar-brand").text("Daily Survey Answer Report");
			}
			else if(this.time==1){
				$(".navbar-brand").text("Weekly Survey Answer Report");
			}
			else if(this.time==2){
				$(".navbar-brand").text("Monthly Survey Answer Report");
			}	
			else{
				$(".navbar-brand").text("Yearly Survey Answer Report");
			}
			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		$('.pages.active a').each(function(){
			if(parseInt($(this).text()) != page)
				$(this).parent('li').removeClass('active');
		});
		if($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
			$('#first, #prev').removeClass('disabled');
		if($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
			$('#next, #last').removeClass('disabled');
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		// get current page of items
		this.pagedItems = this.answeredSurveyList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getAnsweredSurveyList(page, this.limit, this.time);
		}
	}

	// Search survey report
	searchReport = function (time) {
		this.time = time;
		this.getReportDate(time);
		this.getAnsweredSurveyList(1, this.limit, this.time);
	}

	// Set survey options
	setSurveyOptions = function (survey){
		var that = this;
		that.isCountAvailable=true;;
		that.idArr = [];
		that.countArr = [];
		that.selectedSurveyOptions = [];
		$('.waitLoader').show();
		this.authService.getsurveyOption(survey.survey._id, this.time).subscribe(data=>{
			if(data.success){
				
				data.option.forEach(element => {
					that.idArr.push(element._id);
					that.countArr[element._id] = element.count;
				});
				this.selectedSurveyOptions = survey.survey.option;
				$('.waitLoader').hide();
			}
			else{
				$('.waitLoader').hide();
				setTimeout(function(){that.isCountAvailable = false;},0);
			}
		});
	}

	// Get current Date
	getReportDate = function (time) {
		var month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
		var MyDate = new Date();
		var toDateString = ('0' + MyDate.getDate()).slice(-2) + '-'
			+ month_names_short[MyDate.getMonth()] + '-'
			+ MyDate.getFullYear();

		var newDate = MyDate
		if (time === "1")
			newDate.setDate(newDate.getDate() - 7);
		if (time === "2")
			newDate.setMonth(newDate.getMonth() - 1)
		if (time === "3")
			newDate.setFullYear(newDate.getFullYear() - 1);

		var fromDateString = ('0' + newDate.getDate()).slice(-2) + '-'
			+ month_names_short[MyDate.getMonth()] + '-'
			+ newDate.getFullYear();

		if (time != 0) {
			this.reportDate = "From " + fromDateString + " to " + toDateString;
			$('.report_period').css("padding-left", "");
		}
		else {
			this.reportDate = "Today";
			$('.report_period').css("padding-left", 200 + "px");
		}
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/answered-survey-report/answered-survey-report.component.ts